import moment from 'moment';

// One chip per filter category: the filter button count equals the number of chips.
export interface ActiveFilter<K extends string> {
    key: K;
    label: string;
}

/** "Anna Nowak" for one name, "Anna Nowak +2" for more. */
export function namesLabel(names: string[]): string {
    const [first, ...rest] = names.filter(Boolean);
    if (!first) return '';
    return rest.length ? `${first} +${rest.length}` : first;
}

/** "12 Oct – 19 Oct 2026", or a single day when both ends match. */
export function dateRangeLabel(from?: string, to?: string): string {
    if (from && to) {
        const start = moment(from);
        const end = moment(to);
        if (start.isSame(end, 'day')) return end.format('D MMM YYYY');
        const startFormat = start.isSame(end, 'year') ? 'D MMM' : 'D MMM YYYY';
        return `${start.format(startFormat)} – ${end.format('D MMM YYYY')}`;
    }
    if (from) return `From ${moment(from).format('D MMM YYYY')}`;
    if (to) return `Until ${moment(to).format('D MMM YYYY')}`;
    return '';
}

interface Named {
    firstName?: string;
    lastName?: string;
    name?: string;
}

export function displayName(item: Named | null | undefined): string {
    if (!item) return '';
    const full = [item.firstName, item.lastName].filter(Boolean).join(' ').trim();
    return full || item.name || '';
}
